import type { Locale as DatePickerLocale } from "date-picker-svelte";
import { Locale } from "@core/schema/Locale.js";

export const dateInputLocale: Record<Locale, DatePickerLocale> = {
	[Locale.cs]: {
		months: [
			"leden",
			"únor",
			"březen",
			"duben",
			"květen",
			"červen",
			"červenec",
			"srpen",
			"září",
			"říjen",
			"listopad",
			"prosinec",
		],
		weekdays: ["ne", "po", "út", "st", "čt", "pá", "so"],
		shortMonths: ["led", "úno", "bře", "dub", "kvě", "čvn", "čvc", "srp", "zář", "říj", "lis", "pro"],
		weekStartsOn: 1,
	},
	[Locale.en]: {
		months: [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		],
		weekdays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
		shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
		weekStartsOn: 1,
	},
};
